import WeGlide from 'client/javascript/we_glide/we_glide';
import { logError } from 'client/javascript/util/logger';
import { renderSingleUniqueModule } from 'client/javascript/util/geolocation_based_module_rendering/render_single_unique_module';
import { renderMultipleModules } from 'client/javascript/util/geolocation_based_module_rendering/render_multiple_modules';

const SELECTORS = {
  MEDIA_TEXT_ITEM: '.media-text-one-across-item',
  MEDIA_TEXT_GLIDE: '.media-text-one-across__glide',
  ALL_ACCESS_PROMO: '.js-geo-all-access-promo',
  ALL_ACCESS_PROMO_LINK: '.js-geo-media-text-one-across-link'
};

export function setupMediaTextOneAcrossModuleSection() {
  try {
    const mediaTextElements = document.querySelectorAll(SELECTORS.MEDIA_TEXT_ITEM);

    return Array.from(mediaTextElements).reduce((glides, mediaTextElement, index) => {
      if (mediaTextElement.querySelector(SELECTORS.MEDIA_TEXT_GLIDE)) {
        const glide = new WeGlide(
          `${SELECTORS.MEDIA_TEXT_ITEM}:nth-child(1n + ${index + 1}) ${SELECTORS.MEDIA_TEXT_GLIDE}`
        );
        glide.mount();
        glides.push(glide);
      }

      return glides;
    }, []);
  } catch (error) {
    logError(`[Shared modules] setupMediaTextOneAcrossModuleSection failed: ${error.message}`, error);
  }
}

export const setupAllAccessPromoModule = async () => {
  try {
    let moduleDomNode = document.querySelector(SELECTORS.ALL_ACCESS_PROMO);

    if (moduleDomNode) {
      await renderSingleUniqueModule({ context: moduleDomNode.parentNode, selector: SELECTORS.ALL_ACCESS_PROMO });
      // Updated value of context for a link of the module based on its current state in DOM after geo rendering of the module.
      moduleDomNode = document.querySelector(SELECTORS.ALL_ACCESS_PROMO);

      if (moduleDomNode) {
        renderMultipleModules({ context: moduleDomNode, selector: SELECTORS.ALL_ACCESS_PROMO_LINK });
      }
    }
  } catch (error) {
    logError(`[Shared modules] setupAllAccessPromoModule failed: ${error.message}`, error);
  }
};
